export enum ChallengeSection {
    Invites = 'Invites',
    Ongoing = 'Ongoing',
    Completed = 'Completed'
}
